import { usePharma } from '@/providers/PharmaProvider';
import { useNavigate, Navigate } from 'react-router-dom';
import { CRCForm } from '../components/CRCForm';
import { BundleStatusReportPanel } from '@/components/ParticipantTracker/BundleStatusReportPanel';
import { Layout } from '../components/Layout';

export const CRCSelect = () => {
  const navigate = useNavigate();
  const { setIsSiteLoggedIn, isCRC } = usePharma();

  const handleSiteSelect = () => {
    setIsSiteLoggedIn(true);
    navigate('/app/');
  }

  // if (isSiteLoggedIn)
  //   return <Navigate to="/app/" />;

  // // redirect to root if not CRC
  if (!isCRC)
    return <Navigate to="/" />;

  return (
    <Layout title="Log In to a Site | Vivid Vision Perimetry" secondary={<BundleStatusReportPanel />}>
      <CRCForm onSuccess={handleSiteSelect} />
    </Layout>
  );
};
